const action = "SIGNAL_ANALYZE";
export const REQUEST = action + '_REQUEST';
export const RESPONSE = action + '_RESPONSE';
export const CLEAR = action + '_CLEAR';
export const FAILURE = action + '_FAILURE';

// payload: { force?: boolean }
export const fetchRequest = (payload) => ({
  type: REQUEST,
  payload,
});

export const fetchSuccess = (response) => ({
  type: RESPONSE,
  payload: response,
});

export const clearState = () => ({
  type: CLEAR,
});

export const fetchFailure = (error) => ({
  type: FAILURE,
  payload: error,
});
